<template>
  <div id="reports">
    <vx-card collapseAction title="گزارشات">

      <div slot="no-body" class="tabs-container lg:px-6 pt-6 px-1">

        <vs-tabs  class="tab-action-btn-fill-conatiner">
          <vs-tab  :label="!isSmallerScreen ? 'لیست معاملات زیر مجموعه شما' : ''" icon-pack="feather" icon="icon-list">
            <div class="tab-text">
              <p>جهت واریز به کیف پول میتوانید از آدرس ولت زیر استفاده نمایید. همچنین بعد از واریز و کانفیرم شدن، موجودی شما بصورت اتوماتیک بروزسانی میشود.</p>
              <div class="vx-col w-full" >
                <div slot="no-body" class="mt-4" id="table-refrral-transaction">
                  <vs-table stripe
                    :data="referralTransaction"
                    :noDataText="$t('No data Available')"
                    :sst="true"
                    v-model="TransactionsSselected"
                    @change-page="handleChangePage"
                    @search="handleSearch"
                    @sort="handleSort">
                    <template slot="thead">
                      <vs-th class="text-primary">ردیف</vs-th>
                      <vs-th class="w-130 text-primary" sort-key="date">تاریخ و زمان</vs-th>
                      <vs-th class="w-130 text-primary" sort-key="name">نام</vs-th>
                      <vs-th class="w-130 text-primary">شرح</vs-th>
                      <vs-th class="w-90 text-primary" sort-key="amount">کل کارمزد</vs-th>
                      <vs-th class="w-90 text-primary" sort-key="amount">پورسانت شما</vs-th>
                      <vs-th class="w-130 text-primary" sort-key="amount">پورسانت دوستتان</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr]">
                          <span class="flex items-center px-2 py-1 rounded" v-if="!loadData">{{( indextr +1) + (limit * page)-limit}}</span>
                        </vs-td>
                        <vs-td :data="data[indextr].DateTime">
                          <span class="flex items-center px-2 py-1 rounded vazir">{{data[indextr].DateTime}}</span>
                        </vs-td>
                        <vs-td :data="data[indextr].Name">
                          <span>{{(data[indextr].Name)}}</span>
                        </vs-td>
                        <vs-td :data="data[indextr].Description">
                          <span>{{(data[indextr].Description)}}</span>
                        </vs-td>
                        <vs-td :data="data[indextr].total_wage_amount">
                          <span v-if="data[indextr].symbol == 'TOMAN'">
                            {{(data[indextr].total_wage_amount.toLocaleString('en-US'))}} تومان
                          </span>
                          <span v-else>
                            {{toFixFloat(data[indextr].total_wage_amount) +' '+$t(data[indextr].symbol)}}
                          </span>
                        </vs-td>
                        <vs-td :data="data[indextr].amount">
                          <span>
                            {{(data[indextr].amount.toLocaleString('en-US'))}}
                            (%{{data[indextr].for_user == 'caller' ? data[indextr].percent_caller : data[indextr].percent_referral}}) تومان
                          </span>
                        </vs-td>
                        <vs-td :data="data[indextr].percent_referral">
                          <span>
                            {{getCommission(data[indextr])}} تومان
                          </span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>

                  <vs-pagination class="mt-4 vazir" :total="Math.ceil(referralTransactionCount/limit)" v-model="page"></vs-pagination>

                </div>

              </div>
            </div>
          </vs-tab>
          <vs-tab :label="!isSmallerScreen ? 'لیست کاربران معرفی شده' : ''" icon-pack="feather" icon="icon-users">
            <div class="tab-text">
              <p>لیست کاربرانی که توسط شما معرفی شده اند را مشاهده میکنید:</p>
              <div class="vx-col w-full" >
                <div slot="no-body" class="mt-4">
                  <vs-table
                    :data="userReferral"
                    :noDataText="$t('No data Available')"
                    :sst="true"
                    v-model="usersSselected"
                    pagination
                    max-items="10">
                    <template slot="thead">
                      <vs-th>ردیف</vs-th>
                      <vs-th class="w-130">تاریخ ثبت نام</vs-th>
                      <vs-th class="w-130">نام</vs-th>
                      <vs-th class="w-90">درصد شما</vs-th>
                      <vs-th class="w-90">درصد دوستتان</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr]">
                          <span class="flex items-center px-2 py-1 rounded">{{indextr+1}}</span>
                        </vs-td>
                        <vs-td :data="data[indextr].Date">
                          <span class="flex items-center px-2 py-1 rounded vazir">{{data[indextr].Date}}</span>
                        </vs-td>
                        <vs-td :data="data[indextr].Name">
                          <span>{{(data[indextr].Name)}}</span>
                        </vs-td>
                        <vs-td :data="data[indextr].percent_caller">
                          <span>%{{(data[indextr].percent_caller)}}</span>
                        </vs-td>
                        <vs-td :data="data[indextr].percent_referral">
                          <span>%{{(data[indextr].percent_referral)}}</span>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>

              </div>
            </div>
          </vs-tab>
        </vs-tabs>

      </div>
    </vx-card>
  </div>
</template>

<script>
import axios from "../../../axios";

export default {
  props:['referralTransactionCount','userReferral'],
  name: 'reports',
  data () {
    return {
      referralTransaction:[],

      TransactionsSselected : [],
      usersSselected : [],

      page: 1,
      limit: 10,
      loadData: true,
      sort: null,
      sortType: null,
    }
  },
  watch:{
    page(value){
      this.getList()
    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  },
  methods:{
    getList(){
      this.loadData = true;
      if(this.page!=1)
        this.$vs.loading({
          container: '#table-refrral-transaction',
          scale: 0.65
        })

      const self = this
      axios.post('/referrals/list-transaction',{page: this.page, sort:this.sort , sortType:this.sortType})
        .then(function (response) {
          self.referralTransaction = response.data.referral_transaction;
          self.$vs.loading.close('#table-refrral-transaction > .con-vs-loading')
          self.loadData = false;
          /*if( response.data.notif === true)
            self.$store.dispatch('SET_REFRESH_NOTIF', {status: !self.refreshNotifications})*/
        }).catch(function (error) { console.log(error); self.loadData = false; })
    },
    getCommission(item){
      var percent = parseInt(item.for_user !== 'caller' ? item.percent_caller : item.percent_referral);
      var commission = Math.floor((item.total_wage_amount/100) * percent).toLocaleString('en-US');
      return commission+' (%'+percent+')';
    },
    handleChangePage(page) {
      //alert(page);
    },
    handleSort(key, active) {

    },
    handleSearch(searching){
      //alert(searching)
    },

  },
  created() {
    this.getList();
  }
}
</script>

<style lang="scss">


  #reports{

    .w-130 .vs-table-text{
      min-width: 130px;
    }
    .w-90 .vs-table-text{
      min-width: 90px;
    }
    @media only screen and (max-width: 768px) {
      .vs-tabs--li .vs-icon {
        font-size: 25px;
      }
    }
    .ul-tabs .vs-tabs--li button {
      font-weight: bold;
      font-size: 16px;
    }

  }
</style>
